<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>PDF邀请函</h3>
      </div>

      <div class="main">

        <div class="left">
          <img src="../../../static/pdfPreview.png" alt="">
        </div>

        <div class="right">
          <p class="title">第二十届中国国际煤炭采矿技术交流 <br/>
              及设备展览会主题
          </p>
          <p>
            下载PDF文件，邀请观众与您共同参加第二十届 <br/>
            中国国际煤炭采矿技术交流设备展览会
          </p>
          <el-link :href="pdfUrl" download="邀请函">
            <el-button>点击下载</el-button>
          </el-link>
        </div>

      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "pdfInvite",
  created() {
    this.init();
  },
  data () {
    return {
      pdfUrl: '',
    }
  },
  methods: {
    init() {
      //获取邀请函pdf文件
      console.log('获取pdf');
    }
  }

}
</script>

<style lang='scss' scoped>
.body {
  margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #E8E8E8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 114px 0;
    display: flex;
    .left {

    }
    .right {
      align-self: center;
      margin-left: 50px;
      p {
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        font-weight: 400;
      }
      .title {
        color: #006FB8;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        margin-bottom: 16px;
      }
    }
  }



}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
}

>>> .el-button {
  background-color: #006FB8;
  color: #FFFFFF;
  width: 102px;
  height: 32px;
  padding: 0;
  font-weight: 400;
  margin-top: 50px;
}
</style>
